import { lazy } from 'react';

export default lazy(() => import('./Armory' /* webpackChunkName: "item-popup-armory" */));
